import React, { useState, useEffect } from "react";
import "./admincontrols.css";

const ManageProducts = () => {
  const [activeForm, setActiveForm] = useState(""); 
  const [categories, setCategories] = useState([]);
  const [domains, setDomains] = useState([]);
  const [products, setProducts] = useState([]); 
  const [formData, setFormData] = useState({
    product_id:"",
    product_name: "",
    category: "",
    domain: "",
    title: "",
    description: "",
    description2: "",
    specifications: "",
    price: "",
    tax: "",
    warranty_duration: "",
    quantity: "", 
    image: null,
    image1: null,
    image2: null,
    image3: null,
    image4: null,
    video: null,
    documents: [],
    image_path: "",
    image1_path:"",
    image2_path: "",
    image3_path: "",
    image4_path: ""
  });
  const [config, setConfig] = useState(null);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch categories
  useEffect(() => {
    if (!config) return;
    fetch(`${config.BASE_URL}${config.GET_CATEGORIES}`, { method: "POST" })
      .then(res => res.json())
      .then(data => setCategories(data.categories || []))
      .catch(err => console.error("Failed to fetch categories:", err));
  }, [config]);

  // Fetch domains when category changes
  useEffect(() => {
    if (!config || !formData.category) {
      setDomains([]);
      return;
    }
    fetch(`${config.BASE_URL}${config.GET_DOMAINS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ category_name: formData.category })
    })
      .then(res => res.json())
      .then(data => setDomains(data.success ? data.domains || [] : []))
      .catch(err => console.error("Failed to fetch domains:", err));
  }, [formData.category, config]);

  // Fetch all products for update
  useEffect(() => {
    if (!config || activeForm !== "update") return;
    fetch(`${config.BASE_URL}${config.GET_PRODUCTS}`, { method: "POST" })
      .then(res => res.json())
      .then(data => setProducts(data.success ? data.products || [] : []))
      .catch(err => console.error("Failed to fetch products:", err));
  }, [activeForm, config]);

  const resetForm = () => {
    setFormData({
      product_id:"",
      product_name: "",
      category: "",
      domain: "",
      title: "",
      description: "",
      description2: "",
      specifications: "",
      price: "",
      tax: "",
      warranty_duration: "",
       quantity: "",
      image: null,
      image1: null,
      image2: null,
      image3: null,
      image4: null,
      video: null,
      documents: [],
      image_path: "",
      image1_path:"",
      image2_path: "",
      image3_path: "",
      image4_path: ""
    });
  };

  const handleAddNewClick = () => {
    setActiveForm("add");
    resetForm();
    setDomains([]);
  };

  const handleUpdateClick = () => {
    setActiveForm("update");
    resetForm();
    setDomains([]);
  };

const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (files && files[0]) {
    const file = files[0];

    if (name.startsWith("image")) {
      // Check image size
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width === 950 && img.height === 600) {
          setFormData(prev => ({ ...prev, [name]: file }));
        } else {
          alert("Image must be exactly 950*600 pixels.");
          e.target.value = ""; // reset input
        }
        URL.revokeObjectURL(img.src);
      };
    } else if (name === "video") {
      // Check video resolution
      const vid = document.createElement("video");
      vid.src = URL.createObjectURL(file);
      vid.onloadedmetadata = () => {
        if (vid.videoWidth === 950 && vid.videoHeight === 600) {
          setFormData(prev => ({ ...prev, video: file }));
        } else {
          alert("Video must be exactly 950*600 pixels.");
          e.target.value = "";
        }
        URL.revokeObjectURL(vid.src);
      };
    } else if (name === "documents") {
      setFormData(prev => ({ ...prev, documents: Array.from(files) }));
    } else {
      setFormData(prev => ({ ...prev, [name]: file }));
    }
  } else {
    setFormData(prev => ({ ...prev, [name]: value }));
  }
};



  // Select product to update
  const handleProductSelect = (e) => {
    const selectedName = e.target.value;
    setFormData(prev => ({ ...prev, product_name: selectedName }));
    if (!selectedName) return;

    const selectedProduct = products.find(p => p.title === selectedName);
    if (selectedProduct) {
      // Handle documents field properly
      let documentsArray = [];
      if (selectedProduct.documents && selectedProduct.documents !== "[]") {
        // Check if it's a JSON string or comma-separated string
        try {
          // Try to parse as JSON first
          documentsArray = JSON.parse(selectedProduct.documents);
        } catch (error) {
          // If parsing fails, treat it as a comma-separated string
          documentsArray = selectedProduct.documents.split(',');
        }
      }

      setFormData(prev => ({
        ...prev,
        product_id: selectedProduct.product_id,
        product_name: selectedProduct.title,
        category: selectedProduct.category_name,
        domain: selectedProduct.domain_name,
        title: selectedProduct.title,
        description: selectedProduct.description,
        description2: selectedProduct.description2 || "",
        specifications: selectedProduct.specifications || "",
        price: selectedProduct.price,
        tax: (parseFloat(selectedProduct.tax) * 100).toString(),
        warranty_duration: selectedProduct.warranty || "",
        quantity: selectedProduct.quantity || "",
        image: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        video: selectedProduct.videofile || null,
        documents: documentsArray,
        image_path: selectedProduct.image_path,
        image1_path: selectedProduct.image1 || "",
        image2_path: selectedProduct.image2 || "",
        image3_path: selectedProduct.image3 || "",
        image4_path: selectedProduct.image4 || "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!config) return;

    const formPayload = new FormData();
    if (activeForm === "update") formPayload.append("product_name", formData.product_name);

    formPayload.append("category_name", formData.category);
    formPayload.append("domain_name", formData.domain);
    formPayload.append("title", formData.title);
    formPayload.append("description", formData.description);
    formPayload.append("description2", formData.description2);
    formPayload.append("specifications", formData.specifications);
    formPayload.append("price", formData.price);
    formPayload.append("tax", parseFloat(formData.tax) / 100); 
    formPayload.append("warranty_duration", formData.warranty_duration);
    formPayload.append("quantity", formData.quantity);

    if (formData.image) formPayload.append("image", formData.image);
    if (formData.image1) formPayload.append("image1", formData.image1);
    if (formData.image2) formPayload.append("image2", formData.image2);
    if (formData.image3) formPayload.append("image3", formData.image3);
    if (formData.image4) formPayload.append("image4", formData.image4);
    if (formData.video instanceof File) formPayload.append("video", formData.video);
    formData.documents.forEach((doc, i) => {
      if (doc instanceof File) formPayload.append(`documents[${i}]`, doc);
    });

    const endpoint = activeForm === "add"
    ? config.ADD_PRODUCTS   
    : config.UPDATE_PRODUCTS; 

    fetch(`${config.BASE_URL}${endpoint}`, { method: "POST", body: formPayload })
      .then(res => res.json())
      .then(data => {
        alert(data.message || "Action completed");
        resetForm();
        setDomains([]);
      })
      .catch(err => console.error("Failed to submit form:", err));
  };

  return (
    <div className="manage-category-container">
      <h2>Manage Products</h2>

      <div className="button-group">
        <button className="btn add-btn" onClick={handleAddNewClick}>Add New</button>
        <button className="btn update-btn" onClick={handleUpdateClick}>Update</button>
      </div>

      {activeForm && (
        <form className="category-form" onSubmit={handleSubmit}>
          {activeForm === "update" && (
            <label>
              Select Product:
              <select value={formData.product_name} onChange={handleProductSelect} required>
                <option value="">--Select Product--</option>
                {products.map(p => <option key={p.product_id} value={p.title}>{p.title}</option>)}
              </select>
            </label>
          )}

          <label>
            Select Category:
            <select name="category" value={formData.category} onChange={handleChange} required>
              <option value="">--Select--</option>
              {categories.map(cat => <option key={cat.id} value={cat.category_name}>{cat.category_name}</option>)}
            </select>
          </label>

          <label>
            Select Domain:
            <select name="domain" value={formData.domain} onChange={handleChange} required>
              <option value="">--Select--</option>
              {domains.map(d => <option key={d.domain_name} value={d.domain_name}>{d.domain_name}</option>)}
            </select>
          </label>

          <label>Main Image:
            <input type="file" name="image" accept="image/*" onChange={handleChange}/>
            <small style={{ display: "block", color: "#555", marginTop: "4px" }}>
              Upload only 950*600 images
            </small>
            {formData.image_path && (
              <div style={{ marginTop: "5px" }}>
                <img src={`/product_thumbnails/${formData.product_id}/${formData.image_path}`} 
                  alt="Current" style={{ width: "150px", height: "150px", objectFit: "cover" }}/>
              </div>
            )}
          </label>

          {[1,2,3,4].map(i => {
            const imgPath = formData[`image${i}_path`];
            return (
              <label key={i}>
                Image {i}:
                <input type="file" name={`image${i}`} accept="image/*" onChange={handleChange} />
                <small style={{ display: "block", color: "#555", marginTop: "4px" }}>
              Upload only 950×600 images
            </small>
                {imgPath && (
                  <div style={{ marginTop: "5px" }}>
                    <img src={`/product_thumbnails/${formData.product_id}/${imgPath}`} 
                      alt={`Image ${i}`} style={{ width: "150px", height: "150px", objectFit: "cover" }}/>
                  </div>
                )}
              </label>
            );
          })}

          <label>Video:
            <input type="file" name="video" accept="video/*" onChange={handleChange} />
            <small style={{ display: "block", color: "#555", marginTop: "4px" }}>
              Upload only 950*600 videos
            </small>
            {formData.video && (
              <div style={{ marginTop: "5px", fontSize: "14px" }}>
                Selected Video: {formData.video instanceof File ? formData.video.name : formData.video}
              </div>
            )}
          </label>

          <label>Documents (PDFs):
            <input type="file" name="documents" accept="application/pdf" multiple onChange={handleChange} />
            {formData.documents.length > 0 && (
              <div style={{ marginTop: "5px", fontSize: "14px" }}>
                Selected Documents:
                <ul>
                  {formData.documents.map((doc, i) => (
                    <li key={i}>{typeof doc === 'object' ? doc.name : doc}</li>
                  ))}
                </ul>
              </div>
            )}
          </label>

          <label>Title:
            <input type="text" name="title" value={formData.title} onChange={handleChange} required />
          </label>

          <label>Description:
            <textarea name="description" value={formData.description} onChange={handleChange} required />
          </label>

          <label>Additional Description:
            <textarea name="description2" value={formData.description2} onChange={handleChange} />
          </label>

          <label>Specifications:
            <textarea name="specifications" value={formData.specifications} onChange={handleChange} />
          </label>

          <label>Price:
            <input type="number" name="price" value={formData.price} onChange={handleChange} required />
          </label>

          <label>Quantity:
            <input 
              type="number" 
              name="quantity" 
              value={formData.quantity} 
              onChange={handleChange} 
              min="0" 
              required 
            />
          </label>

          <label>Tax (%):
            <input type="number" name="tax" value={formData.tax} onChange={handleChange} required />
          </label>

          <label>Warranty Duration:
            <input type="text" name="warranty_duration" value={formData.warranty_duration} onChange={handleChange} />
          </label>

          <button type="submit" className="submit-btn">
            {activeForm === "add" ? "Save Product" : "Update Product"}
          </button>
        </form>
      )}
    </div>
  );
};

export default ManageProducts;